import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CheckCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Numeral } from "react-numeral";

import { PrimaryMobile } from "../../../buttons/mobile/Primary";
import { CreditUserContext } from "../../../../context/CreditUser/CreditUserContext";
import { rewardsPercentage, roundToNearestMultipleOfTen } from "../../../../utils/rewards/rewardsUtils";
import { convertToNumber, isValidNumber } from "../../../../utils/isValidNumber";
import { RewardModal } from './RewardModal';
import { APIClient } from "../../../../helpers/api_helper";
import { GET_REWARDS, INCREMENT_QUOTA_FROM_REWARD_SELECTED, UPDATE_QUOTA_STATUS, UPDATE_REWARD_HISTORY } from "../../../../helpers/url_helper";
import { LoadingView } from "../../../loading/Loading";
import { calcTotalAPagar } from "../../../../utils/creditUser/calcTotalAPagar";
import { getCurrentUTCDate } from "../../../../utils/getUtcDate";
import { XCircle } from "heroicons-react";
import { HttpRequest } from "../../../../services/httpRequest";
import { firmaElectronica } from "../../../../utils/creditUser/helpers";

const api = new APIClient();
const topeCupo = 1500000;

export function ChooseReward({
  rewards,
  closeRewardHistory,
  idHistoryReward,
  setIsUsedReward,
  isUsedReward
}) {
  const { updateDatosVarios, datosVarios } = useContext(CreditUserContext);
  const [open, setOpen] = useState(false);
  const [selectedReward, setSelectedReward] = useState({});
  const [dataRewards, setDataRewards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [approvedQuota, setApprovedQuota] = useState(0);
  const [newApprovedQuota, setNewApprovedQuota] = useState(0);
  const [cupoObtenido, setCupoObtenido] = useState(0);
  const [totalToPay, setTotalToPay] = useState(0);
  const [newTotalToPay, setNewTotalToPay] = useState(0);
  const [discountReward, setDiscountReward] = useState(0);
  const [percentageDiscountSignature, setPercentageDiscountSignature] = useState(0);
  const [percentageDiscountApprovedQuota, setPercentageDiscountApprovedQuota] = useState(0);
  const [errorAlert, setErrorAlert] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [loadingActions, setLoadingActions] = useState(false);
  const [textLoading, setTextLoading] = useState("");
  const [initialPoints, setInitialPoints] = useState(0);
  const [finalPoints, setFinalPoints] = useState(0);
  const [operation, setOperation] = useState('');
  const [rewardsData, setRewardsData] = useState([]);
  const [cupoDisponibleInicial, setCupoDisponibleInicial] = useState(0);
  const [cupoAprobadoInicial, setCupoAprobadoInicial] = useState(0);

  const handleSelectReward = (index, reward) => {
    let newReward = { ...reward, index };
    setSelectedReward(newReward);
  }

  const handleClose = () => {
    setIsLoading(false);
    setOpen(false);
    setErrorAlert(false);
    setIsLoading(false);
    setLoadingActions(false);
    setTextLoading("");
    setInitialPoints(0);
    setFinalPoints(0);
    setDialogContent("");
    setSelectedReward(null);
    setDataRewards([]);
    setApprovedQuota(0);
    setNewApprovedQuota(0);
    setCupoObtenido(0);
    setTotalToPay(0);
  }

  const handleConfirm = async () => {
    const rewardTypes = {
      '10': {
        dialogContent: 'Ahorrarás en firma electrónica',
        textLoading: 'Generando recompensa...',
        action: handleUpdateDctoFirmaElectronica,
        initialPoints: totalToPay,
        finalPoints: newTotalToPay,
        operation: 'firma',
        percentageDiscount: percentageDiscountSignature,
        discount: discountReward
      },
      '00': {
        dialogContent: 'Tu nuevo cupo es de',
        textLoading: 'Generando recompensa...',
        action: handleSubmitQuota,
        initialPoints: approvedQuota,
        finalPoints: newApprovedQuota,
        operation: 'cupo',
        percentageDiscount: percentageDiscountApprovedQuota,
        discount: discountReward
      },
    };

    const selectedRewardType = String(selectedReward?.shortCode).substring(1, 3);
    setLoadingActions(true);
    if (rewardTypes[selectedRewardType]) {
      try {
        setDialogContent(rewardTypes[selectedRewardType].dialogContent);
        setTextLoading(rewardTypes[selectedRewardType].textLoading);
        setInitialPoints(rewardTypes[selectedRewardType].initialPoints);
        setFinalPoints(rewardTypes[selectedRewardType].finalPoints);
        setOperation(rewardTypes[selectedRewardType].operation);
        await rewardTypes[selectedRewardType].action();
        await handleUpdateRewardUsed(rewardTypes[selectedRewardType].percentageDiscount);
        setTimeout(() => {
          setLoadingActions(false);
          setModalOpen(true);
        }, 2500);
      } catch (error) {
        console.log(error);
        handleOpenErrorAlert();
        return handleCloseDisclosureForError();
      }
    } else {
      console.error('Tipo de recompensa no reconocido');
      handleOpenErrorAlert();
      return handleCloseDisclosureForError();
    }

    // return navigate(selectedReward?.href ?? "#");
  };

  const handleCalcPercentageSignature = (reward) => {
    let _firmaElectronica = firmaElectronica;
    let rewards = rewardsData.length > 0 ? rewardsData : rewardsPercentage;
    let percentage = rewards.filter((r) => reward?.shortCode === r.shortCode)[0]?.percentage;
    setPercentageDiscountSignature(percentage);
    let discountReward = (_firmaElectronica * percentage) / 100;
    let nuevoTotalAPagar = totalToPay - discountReward;
    setNewTotalToPay(nuevoTotalAPagar);
    setDiscountReward(discountReward);
    return;
  };

  const handleIncrementQuota = (reward) => {
    let rewards = rewardsData.length > 0 ? rewardsData : rewardsPercentage;
    let percentage = rewards.filter((r) => reward?.shortCode === r.shortCode)[0]?.percentage;
    setPercentageDiscountApprovedQuota(percentage);
    let cupoObtenido = approvedQuota * percentage / 100;
    let cupoObtenidoRounded = roundToNearestMultipleOfTen(cupoObtenido);
    let newApprovedQuota = approvedQuota + cupoObtenidoRounded;
    setNewApprovedQuota(newApprovedQuota);
    setCupoObtenido(cupoObtenido);
    return;
  };

  const handleSubmitQuota = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        let _cupoDisponible = cupoDisponibleInicial;
        let _cupoAprobado = cupoAprobadoInicial;
        let update = { cupoAprobado: newApprovedQuota };
        if (_cupoDisponible && _cupoDisponible !== "0") {
          if (_cupoDisponible === _cupoAprobado) {
            _cupoDisponible = newApprovedQuota;
            update = { cupoAprobado: newApprovedQuota, cupoDisponible: _cupoDisponible };
          }
        }
        let response = await api.put(INCREMENT_QUOTA_FROM_REWARD_SELECTED + "/" + localStorage.getItem('doc'), update);
        if (response.status !== 200) {
          return reject(response?.data?.message);
        }
        updateDatosVarios({ ...datosVarios, cupoAprobado: newApprovedQuota, cupoDisponible: _cupoDisponible });
        resolve(true);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }

  const handleUpdateDctoFirmaElectronica = async () => {
    try {
      console.log('ok');
    } catch (error) {
      console.error(error);
    }
  }

  const handleUpdateRewardUsed = async (percentageDiscount) => {
    try {
      await api.put(
        UPDATE_REWARD_HISTORY + idHistoryReward,
        {
          update: {
            used: true,
            percentDiscount: percentageDiscount,
            rewardSelectedId: selectedReward?._id,
            updatedAt: getCurrentUTCDate()
          }
        });
    } catch (error) {
      console.error(error);
    }
  }

  const closeModal = () => {
    setModalOpen(false);
    closeRewardHistory();
    setIsUsedReward(!isUsedReward);
    //return navigate('/renovar');
  }

  const handleOpenErrorAlert = () => {
    setErrorAlert(true);
  }

  const handleCloseDisclosureForError = () => {
    setTimeout(() => {
      setErrorAlert(false);
      handleClose();
      closeRewardHistory();
      return;
    }, 5000);
  };

  const getQuotaInfo = async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
      return {};
    }
  }

  useEffect(() => {
    let approvedQuota = null;

    let getApprovedQuota = async () => {
      let data = await getQuotaInfo();
      setCupoDisponibleInicial(data?.cupoDisponible);
      setCupoAprobadoInicial(data?.cupoAprobado);
      return data?.cupoAprobado;
    }

    let getRewards = async () => {
      try {
        let response = await api.get(GET_REWARDS);
        let rewards = response.data?.data ?? []
        return rewards;
      } catch (error) {
        console.error(error);
        return []
      }
    }

    (async () => {
      approvedQuota = await getApprovedQuota();
      let rewards = await getRewards();
      setRewardsData(rewards);
      if (!approvedQuota) {
        handleOpenErrorAlert();
        return handleCloseDisclosureForError();
      }
      approvedQuota = convertToNumber(approvedQuota);
      if (!isValidNumber(approvedQuota)) {
        console.error('approvedQuota no es un número válido.');
        handleOpenErrorAlert();
        return handleCloseDisclosureForError();
      }
      let totalToPay = calcTotalAPagar(approvedQuota, 30);
      totalToPay = convertToNumber(totalToPay);
      if (!isValidNumber(totalToPay)) {
        console.error('approvedQuota o totalToPay no es un número válido.');
        handleOpenErrorAlert();
        return handleCloseDisclosureForError();
      }
      setApprovedQuota(approvedQuota);
      setTotalToPay(totalToPay);
      return;
    })();
  }, [cupoObtenido]);

  useEffect(() => {
    try {
      let index = 0;
      let newSelectedReward = rewards[index];
      let _approvedQuota = approvedQuota;
      newSelectedReward.index = index;
      setSelectedReward(newSelectedReward);
      if (_approvedQuota >= topeCupo) {
        console.log('El cupo aprobado es mayor al cupo tope');
        let filterIncQuota = "00";
        rewards = rewards.filter(reward => String(reward?.shortCode).substring(1, 3) !== filterIncQuota);
      }
      setDataRewards(rewards);
      handleCalcPercentageSignature(newSelectedReward);
      handleIncrementQuota(rewards[1]);
      setIsLoading(false);
      return;
    } catch (error) {
      console.log(error);
      handleOpenErrorAlert();
      return handleCloseDisclosureForError();
    }
  }, [approvedQuota, totalToPay, newTotalToPay]);

  if (isLoading) {
    return (
      <LoadingView text={"Cargando..."} />
    )
  }

  return (
    <>
      {
        modalOpen && (
          <RewardModal
            isOpen={modalOpen}
            closeModal={closeModal}
            initialPoints={initialPoints}
            finalPoints={finalPoints}
            dialogTitle={"¡Recompensa obtenida!"}
            dialogContent={dialogContent}
            operation={operation}
          />
        )
      }
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-end">
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed bg-transparent inset-0 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed bottom-0 right-0 h-100 flex max-w-full md:pl-10" style={{ height: '29em' }}>
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="bg-purpleLight h-full rounded-t-3xl font-walsheim tracking-tight p-4">
                  <div className="">
                    <div className="flex justify-between">
                      <div className="">
                        <button
                          type="button"
                          onClick={handleClose}
                          className="text-tdark focus:outline-none"
                        >
                          <span className="" />
                          <span className="sr-only">Close panel</span>
                          <ArrowLeftIcon
                            aria-hidden="true"
                            className="h-6 w-6"
                          />
                        </button>
                      </div>
                      <DialogTitle>
                        <div className="">Elige tu recompensa</div>
                      </DialogTitle>
                      <button
                        type="button"
                        onClick={handleClose}
                        className="text-tdark focus:outline-none"
                      >
                        <span className="" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                      </button>
                    </div>
                  </div>

                  <div className="text-tdark h-full grid content-between pb-8 pt-4">

                    <div className="">
                      {
                        errorAlert ? (
                          <>
                            <div className="flex justify-center py-2">
                              {" "}
                              <span className="text-sm text-red pt-2">
                                Error al cargar los datos, intenta nuevamente
                              </span>{" "}
                            </div>
                            <div className="flex justify-center text-red py-2">
                              <XCircle className="w-20 h-auto" />
                            </div>
                          </>
                        ) : (
                          (dataRewards ?? []).map((reward, index) => (
                            <Link onClick={() => handleSelectReward(index, reward)} key={index}>

                              <div className={`bg-white rounded-3xl p-4 mb-4 ${selectedReward?.index === index ? "shadow-xl" : "shadow-sm"}`} key={index}>

                                <div className="flex justify-between">
                                  <div className="font-bold">
                                    {reward?.description}
                                  </div>
                                  <div className={`w-5 h-5 rounded-full ${selectedReward?.index === index ? "bg-green" : "bg-purpleLight"}`}>
                                    <CheckCircleIcon color="white"></CheckCircleIcon>
                                  </div>
                                </div>

                                {
                                  String(reward.shortCode).includes('10') && (
                                    <div>Ahorra {" "}
                                      <Numeral
                                        className="text-md font-bold"
                                        format={"$0,0"}
                                        value={discountReward} />
                                      {" "}
                                      en firma electrónica
                                    </div>
                                  )
                                }

                                {
                                  String(reward.shortCode).includes('00') && (
                                    <div>Aumentarás tu cupo de crédito a {" "}
                                      <Numeral
                                        className="text-md font-bold"
                                        format={"$0,0"}
                                        value={newApprovedQuota} />
                                    </div>
                                  )
                                }
                              </div>
                            </Link>
                          ))
                        )
                      }

                    </div>

                    {
                      loadingActions && (
                        <LoadingView text={textLoading} />
                      )
                    }

                    <Link className="block" onClick={handleConfirm}>

                      <button
                        disabled={loadingActions || errorAlert}
                        type="button"
                        className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-lg text-white font-semibold ${loadingActions || errorAlert ? "bg-tgray" : "bg-purple hover:bg-purpleDark hover:scale-110 transition duration-300  focus:outline-none"}`}
                      >
                        <div className="flex">
                          Confirmar
                        </div>
                      </button>

                    </Link>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
